<script lang="ts">
  export let size = 20;
</script>

<svg width={size} height={size} viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.7809 0.0743218C12.3355 0.306976 11.0818 0.999468 10.0013 2.1619L9.58026 2.61487L9.37111 2.31801C6.98514 -1.06891 1.95496 -0.424164 0.282459 3.48297C-0.0940448 4.36252 -0.0940831 4.52238 0.281925 5.37755C1.2419 7.56087 3.83278 8.0922 5.43428 6.43414C6.21498 5.62587 7.19497 5.54402 7.91135 6.22734L8.03567 6.3459L7.9927 6.72481C7.82037 8.2441 8.23011 10.1802 9.00248 11.4964C9.31448 12.028 9.74663 12.1457 10.1778 11.8163C10.5099 11.5626 10.5449 11.232 10.3326 10.3516C9.75988 7.97608 11.7592 6.1289 13.8024 7.14583C16.5745 8.52555 19.7804 5.68359 19.1739 2.38415C19.0424 1.66918 19.0263 1.63504 18.6992 1.37994C17.297 0.286557 15.472 -0.197867 13.7809 0.0743218Z"
    class={$$props.class || "fill-current"}
  />
</svg>
